// EventCalendar.tsx
import React from "react";

import { Event } from "0.Mine/3.Interfaces/Event";

import { useEventCalendarLogic } from "../Logic/EventCalendarLogic";
import { EventCalendarUI } from "../UI/EventCalendar";

interface CalendarViewProps {
  events: Event[];
  onSelectEvent: (event: Event) => void;
  onSelectSlot: ({ start, end }: { start: Date; end: Date }) => void;
}

export const EventCalendar: React.FC<CalendarViewProps> = ({
  events,
  onSelectEvent,
  onSelectSlot,
}) => {
  const { styles, handleSelect, handleEventClick, handleEventDidMount } = useEventCalendarLogic(
    onSelectEvent,
    onSelectSlot
  );

  return (
    <EventCalendarUI
      events={events}
      styles={styles}
      handleSelect={handleSelect}
      handleEventClick={handleEventClick}
      handleEventDidMount={handleEventDidMount}
    />
  );
};

export default EventCalendar;
